export default {
  feedback: {
    reasons: "Reasons",
    reason: "Reason",
    feeling: "Face expression",
    feeling_enum: {
      BAD: "Bad",
      SAD: "Sad",
      NORMAL: "Normal",
      HAPPY: "Happy",
      ECSTATIC: "Very Happy"
    },
    title: "Feedback {0} / {1}",
    comment: "Description"
  }
};
